import { FC } from "react";

import { NotificationItemFooterDefinition } from "./notification-item-footer-definition";
import { NotificationItemFooterStyled } from "./notification-item-footer.styled";

export interface INotificationItemFooterDefinition {
  title: string;
  description: string;
}

interface INotificationItemFooterProps {
  footerItems: INotificationItemFooterDefinition[];
}

export const NotificationItemFooter: FC<INotificationItemFooterProps> = ({
  footerItems,
}) => {
  return (
    <NotificationItemFooterStyled>
      {footerItems.map(({ title, description }) => (
        <NotificationItemFooterDefinition
          key={`${title}_${description}`}
          title={title}
          description={description}
        />
      ))}
    </NotificationItemFooterStyled>
  );
};
